import React, { useState } from 'react';
import './ui-promo.scss';
import UIIcon from '../UIIcon';
import { Trashcan } from '../../../assets/icons';
import { getPromoTypeText } from '../../../utils/Helpers/PaymentHelper/PaymentHelper';
import { isUserAdminOrRM } from '../../../utils/Helpers/UserHelpers';
import { getPromoDiscount, getPromoUsesRemaining } from '../../../utils/Helpers/PromoHelpers';
import { PROMOS } from '../../../utils/Config/Constants';
import UIModal from '../UIModal';
import UIIconButton from '../UIIconButton';
import UIOverlayCard from '../UIOverlayCard';
import { UI_ICON_BUTTON_CANCEL_TYPE } from '../UIIconButton/config';
import { useDispatch, useSelector } from 'react-redux';
import { getSignedInUserSelector } from '../../../redux/selectors/CurrentUserSelectors';
import { showOption } from '../../../redux/store/user/actions';

const UIPromo = ({ promo, removePromo }) => {
	const signedInUser = useSelector(getSignedInUserSelector);

	const [isRemovingPromo, setIsRemovingPromo] = useState<boolean>(false);
	const [showRemovePromoModal, setShowRemovePromoModal] = useState<boolean>(false);

	const dispatch = useDispatch();

	const onClickCard = () => {
		if (promo.promoType === PROMOS.promoTypes.specificOption && isUserAdminOrRM(signedInUser)) {
			dispatch(showOption(promo.option.id));
		}
	};

	const onClickDelete = (e) => {
		e.stopPropagation();
		setShowRemovePromoModal(true);
	};

	const showRemoveOverlay = () => {
		const hideModal = () => setShowRemovePromoModal(false);

		return (
			<UIModal condition={showRemovePromoModal}>
				<UIOverlayCard hideModal={hideModal} title={'Remove promo'} description={'Are you sure you want to remove this promo?'}>
					<div className='uiCard__buttons' style={{ marginTop: 16 }}>
						<UIIconButton
							dark
							type={UI_ICON_BUTTON_CANCEL_TYPE}
							text={'yes, remove'}
							isLoading={isRemovingPromo}
							onClick={async () => {
								setIsRemovingPromo(true);
								await removePromo(promo);
								setIsRemovingPromo(false);
								setShowRemovePromoModal(false);
							}}
						/>
					</div>
				</UIOverlayCard>
			</UIModal>
		);
	};

	return (
		<div key={promo.id} className='promo-card-container'>
			<div className='promo-card' key={promo.id} onClick={onClickCard}>
				<p className='promo-price-text'>{getPromoDiscount(promo)}</p>
				<p className='promo-amount-text'>{getPromoTypeText(promo)}</p>
				<p className='promo-uses-text'>{getPromoUsesRemaining(promo)}</p>
				<div onClick={onClickDelete}>
					<UIIcon alt='delete' className='promo-edit-icon' iconSrc={Trashcan.white} />
				</div>
			</div>
			{showRemoveOverlay()}
		</div>
	);
};

export default UIPromo;
